module.exports = __webpack_public_path__ + "a25fb14bd372d86421bab89b77c9c84f.png";